import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import Layout from './components/layout/Layout';
import Loader from './components/common/Loader';
import ScrollToTop from './components/common/ScrollToTop';
import PrakritiAnalysis from './pages/PrakritiAnalysis';

const Home = lazy(() => import('./pages/Home'));
const FertilityPanchakarma = lazy(() => import('./pages/FertilityPanchakarma'));
const FertilityNutrition = lazy(() => import('./pages/FertilityNutrition'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const Contact = lazy(() => import('./pages/Contact'));
const SuccessStories = lazy(() => import('./pages/SuccessStories'));
const Blogs = lazy(() => import('./pages/Blogs'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));

function App() {
  return (
    <HelmetProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <ScrollToTop />
        <Suspense fallback={<Loader />}>
          <Routes>
            {/* Admin Routes (without Layout) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />

            {/* Public Routes (with Layout) */}
            <Route path="/*" element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/fertility-panchakarma" element={<FertilityPanchakarma />} />
                  <Route path="/fertility-nutrition" element={<FertilityNutrition />} />
                  <Route path="/about" element={<AboutUs />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/prakriti-analysis" element={<PrakritiAnalysis />} />
                  <Route path="/success-stories" element={<SuccessStories />} />
                  <Route path="/blog" element={<Blogs />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                </Routes>
              </Layout>
            } />
          </Routes>
        </Suspense>
        <Toaster position="bottom-right" />
      </Router>
    </HelmetProvider>
  );
}

export default App;